import { Box } from '@chakra-ui/react';
import { WheelEventHandler, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useKeyPress } from '$/hooks/useKeyPress';
import { ModuleSendSelectAction } from '$/pages/EditorPage/hooks/moduleCommunicationActions';
import { useEditorActions } from '$/pages/EditorPage/hooks/useEditorActions';
import { useEditorModuleListener } from '$/pages/EditorPage/hooks/useEditorModuleListener';
import {
  MAXZOOMLEVEL,
  MINZOOMLEVEL,
  useEditorStore,
} from '$/pages/EditorPage/stores/useEditorStore';
import { editorEndpoints } from '$/services/endpoints';

export const ModuleSection = () => {
  const editorModuleRef = useEditorStore.useEditorModuleRef();
  const zoomPercent = useEditorStore.useZoomPercent();
  const { t } = useTranslation();
  const { moduleMessageListener } = useEditorModuleListener();
  const { selectAction, zoomPercentage } = useEditorActions();

  useKeyPress(({ key, ctrl, shift }) => {
    if (ctrl && key === '0') {
      zoomPercentage(100);
    }
    if (key === '+') {
      const newZoomLevel = zoomPercent + 25;
      const zoomLevelInBounds = Math.min(MAXZOOMLEVEL, newZoomLevel);
      zoomPercentage(zoomLevelInBounds);
    }
    if (key === '-') {
      const newZoomLevel = zoomPercent - 25;
      const zoomLevelInBounds = Math.max(MINZOOMLEVEL, newZoomLevel);
      zoomPercentage(zoomLevelInBounds);
    }
    if (shift && key === '!') {
      selectAction(ModuleSendSelectAction.ZoomInnerfit);
    }
  }, []);

  const onWheel: WheelEventHandler = (event) => {
    if (event.deltaY > 0) {
      const newZoomLevel = zoomPercent - 25;
      const zoomLevelInBounds = Math.max(MINZOOMLEVEL, newZoomLevel);
      zoomPercentage(zoomLevelInBounds);
    } else if (event.deltaY < 0) {
      const newZoomLevel = zoomPercent + 25;
      const zoomLevelInBounds = Math.min(MAXZOOMLEVEL, newZoomLevel);
      zoomPercentage(zoomLevelInBounds);
    }
  };

  useEffect(() => {
    window.addEventListener('message', moduleMessageListener);

    return () => {
      window.removeEventListener('message', moduleMessageListener);
    };
  }, [moduleMessageListener]);

  return (
    <Box
      pos='fixed'
      zIndex='-1'
      w='100vw'
      h='100vh'
      id='imgBox'
      onWheel={onWheel}
    >
      <iframe
        src={editorEndpoints.EDITOR_SRC}
        ref={editorModuleRef}
        title={t('editor.moduleTitle')}
        width='100%'
        height='100%'
      />
    </Box>
  );
};
